import { motion } from 'framer-motion';
import React from 'react';
import ChevronDown from './ChevronDown';

interface DynamicChevronProps {
  onChange: () => void;
  folded: boolean;
}

const DynamicChevron: React.FC<DynamicChevronProps> = ({ onChange, folded }) => {
  return (
    <motion.div
      onClick={onChange}
      animate={{
        rotate: folded ? 0 : 180,
      }}
      transition={{ type: 'spring', stiffness: 200, damping: 15 }}
    >
      <ChevronDown />
    </motion.div>
  );
};

export default DynamicChevron;
